import { makeObservable, observable, computed, action } from 'mobx';

export default class Participant {
    uuid;
    first_name;
    last_name;
    school_name;
    is_walk_in;
    registration_id;
    email;
    email_second;
    onsite_status = 'active';
    registration_status;
    is_editing = false;
    sent_special_invite = false;
    checkins = [];

    constructor(data, { csrf, guid }) {
        makeObservable(this, {
            uuid: observable,
            first_name: observable,
            last_name: observable,
            school_name: observable,
            is_walk_in: observable,
            registration_id: observable,
            email: observable,
            email_second: observable,
            checkins: observable,
            onsite_status: observable,
            registration_status: observable,
            is_editing: observable,
            status: computed,
            registration_type: computed,
            sent_special_invite: observable,
            full_name: computed,
            searchable_name: computed,
            sort_name: computed,
            is_outside_participant: computed,
            update: action.bound,
            check_in: action.bound,
            remove_check_in: action.bound
        });

        this.csrf = csrf;
        this.guid = guid;
        this.update(data);
    }

    get status() {
        if (this.checkins.length) {
            return 'active';
        }

        return this.onsite_status
    }

    get registration_type() {
        if (this.registration_id) {
            return 'Outside';
        }

        return '';
    }

    get full_name() {
        return `${this.first_name} ${this.last_name}`;
    }

    get searchable_name() {
        return this.full_name.replace(/\s+/g, '').toLowerCase();
    }

    get sort_name() {
        return `${this.last_name}${this.first_name}`.toLowerCase();
    }

    get is_outside_participant() {
        if (typeof this.registration_id == 'undefined') {
            return false;
        }

        if (this.registration_id > 0) {
            return true;
        }

        if (this.registration_id < 0) {
            return true;
        }

        return false;
    }

    set is_outside_participant(yesNo) {
        const { registration_id } = this;

        if (parseInt(registration_id, 10) === -1) {
            this.registration_id = 0;
        } else if (parseInt(registration_id, 10) > 0) {
            // No op
        } else {
            this.registration_id = -1;
        }
    }

    update(data) {
        if (data.uuid) {
            this.uuid = data.uuid;
        }

        if (data.first_name) {
            this.first_name = data.first_name;
        }

        if (data.last_name) {
            this.last_name = data.last_name;
        }

        if (data.school_name) {
            this.school_name = data.school_name;
        }

        if (data.is_walk_in !== undefined) {
            this.is_walk_in = !!data.is_walk_in;
        }

        if (data.checkins) {
            this.checkins = observable(data.checkins);
        }

        if (data.onsite_status) {
            this.onsite_status = data.onsite_status;
        }

        if (data.registration_status) {
            this.registration_status = data.registration_status;
        }

        if (data.registration_id) {
            this.registration_id = data.registration_id;
        }

        if (data.email) {
            this.email = data.email;
        }

        if (data.email_second) {
            this.email_second = data.email_second;
        }

        if (data.sent_special_invite) {
            this.sent_special_invite = !!data.sent_special_invite;
        }
    }

    check_in(date) {
        $.ajax({
            method: 'get',
            url: `/workshops/${this.guid}/attendance/check-in/add/`,
            data: { csrfmiddlewaretoken: this.csrf, uuid: this.uuid, date: date.to_s }
        }).then(d => {
            let data = {};

            try {
                data = JSON.parse(d);
            } catch (e) {}

            this.update(data);
        });
    }

    remove_check_in(date) {
        $.ajax({
            method: 'get',
            url: `/workshops/${this.guid}/attendance/check-in/remove/`,
            data: { csrfmiddlewaretoken: this.csrf, uuid: this.uuid, date: date.to_s }
        }).then(d => {
            let data = {};

            try {
                data = JSON.parse(d);
            } catch (e) {}

            this.update(data);
        });
    }

    save() {
        $.ajax({
            method: 'post',
            url: `/workshops/${this.guid}/attendance/participant/`,
            data: {
                csrfmiddlewaretoken: this.csrf,
                uuid: this.uuid,
                first_name: this.first_name,
                last_name: this.last_name,
                registration_id: this.registration_id,
                sent_special_invite: !!this.sent_special_invite,
            }
        }).then(d => {
            let data = {};

            try {
                data = JSON.parse(d);
            } catch (e) {}

            this.update(data);
        });

        return true;
    }
}
